import { settingsAccountDetailsActions } from './settingsAccountDetailsActions';
import { settingsDeliveryActions } from './settingsDeliveryActions';
import { settingsPreferencesActions } from './settingsPreferencesActions';
import {
  LINK_USAGE_STATUS_CONFIRM,
  LINK_USAGE_STATUS_PENDING,
} from '../actions/accountDetails/paymentUsage';
import { SET_SUPERUSER_CHECKOUT_SETTINGS } from '../actions/superuserCheckout';

export const initialState = {
  useAdditionalBags: false,
  ownOffers: false,
  thirdPartyOffers: false,
  marketingConsents: {},
  calendarAttachmentsEnabled: false,
  skipHealthify: false,
  currentSmsNumber: null,
  primaryNumber: null,
  secondaryNumber: null,
  hasSlotSubscription: false,
  isRemoveNumberConfirmOpen: false,
  facebookId: null,
  facebookLinked: false,
  facebookAccountAlreadyLinkedPopupOpen: false,
  facebookLoginNotPossiblePopupOpen: false,
  contactDetails: {},
  contactDetailsValidationErrors: null,
  paypalId: null,
  paypalLinked: false,
  paypalAccountAlreadyLinkedPopupOpen: false,
  paypalLoginNotPossiblePopupOpen: false,
  deliveryAddresses: [],
  registrationPostcode: null,
  deleteDeliveryAddressError: null,
  hasPassword: true,
  changePasswordValidationErrors: {},
  changeEmailValidationErrors: {},
  addAddress: {
    addresses: [],
    postcode: '',
    city: '',
    addressNickname: '',
    manualAddressLine: '',
    deliveryInstructions: '',
    postcodeErrorCode: '',
    manualAddressError: '',
    cityError: '',
    selectedAddressId: '',
    typeAddressManually: false,
    canDeliver: false,
  },
  addressToEdit: null,
  groupedPaymentTokens: {},
  possibleUsages: [],
  linkUsageStatus: LINK_USAGE_STATUS_CONFIRM,
  linkUsagePaymentStatus: LINK_USAGE_STATUS_PENDING,
  linkUsagePaymentUrl: '',
  errorMessage: null,
  paymentMethodError: null,
  hasContactAddress: false,
  freeDeliveryEnabled: false,
  deliveryPassFailedDataHolder: undefined,
};

const ACTIONS = {
  ...settingsAccountDetailsActions,
  ...settingsDeliveryActions,
  ...settingsPreferencesActions,
  /* OTHERS */
  [SET_SUPERUSER_CHECKOUT_SETTINGS]: ({ state, action }) => ({
    ...state,
    freeDeliveryEnabled: action.freeDeliveryEnabled,
  }),
};

export default function settings(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
